import { observer } from "mobx-react-lite";
import { GalleryGrid } from "../../../app/common/controls/GalleryGrid"; // generic layout
import { useNavigate } from "react-router-dom";
import {useStore} from "../../../app/stores/rootStore";
export default observer(function ProductGalleryComponent({ title }) {
    const { productsStore } = useStore();
    const { ParentCategories, productreload, loadProductList, setProductReload,setItem } = productsStore;
    const navigate = useNavigate();
    return (
        <GalleryGrid
            title={title}
            items={ParentCategories}
            isReloading={productreload}
            loadAction={loadProductList}
            setReloadAction={setProductReload}
            renderItem={(product) => (
                <div className="item features-image col-6 col-md-6 col-lg-3" key={product.id}>
                    <div className="item-wrapper">
                        <div className="item-img">
                        {product.displayMode === "video" ? <video  controls autoPlay={true} loop muted>
        <source src={product.mainImageUrl} type="video/mp4" />
        Your browser does not support the video tag.
              </video> : <img src={product.mainImageUrl} alt={product.name} /> }
                        </div>
                        <div className="item-content align-center">
                            <h5 className="item-title mbr-fonts-style mb-0 display-7">{product.name}</h5>
                            <p className="item-subtitle mbr-fonts-style mb-0 display-7">
                                <strong>{product.title}</strong>
                            </p>
                            <p className="mbr-text mbr-fonts-style mb-0 display-7">
                                <strike>Rs. {product.productStrikePrice}</strike><br/>
                                <strong>Rs. {product.productPrice}</strong>
                            </p>
                        </div>
                        {/* Spacing replaced with CSS margin if possible, but kept for logic consistency */}
                        <div style={{ marginBottom: '4rem' }} /> 
                        <div className="mbr-section-btn align-center">
                            <a style={{cursor:'pointer'}} onClick={()=>{
                            setItem(product);                                               
                            navigate(`/product/${product.id}`);
                        }} className="btn item-btn btn-danger display-7">
                                Buy
                            </a>
                        </div>
                    </div>
                </div>
            )}
        />
    );
});